/**
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the Commercial License found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
Object.defineProperty(exports, "rowExpandColumnId", {
  enumerable: true,
  get: function get() {
    return _defaultRowExpandColumnId.id;
  }
});
var _react = _interopRequireDefault(require("react"));
var _defaultRowExpandColumnId = require("@inovua/reactdatagrid-community/normalizeColumns/defaultRowExpandColumnId");
var ICON_EXPANDED = _react.default.createElement("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, _react.default.createElement("path", {
  d: "M19 13H5v-2h14v2z"
}));
var ICON_COLLAPSED = _react.default.createElement("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, _react.default.createElement("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}));
var ICON_MORE = _react.default.createElement("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  style: {
    position: 'relative',
    top: 3
  }
}, _react.default.createElement("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}));
var renderExpandIcon = function renderExpandIcon(_ref) {
  var renderRowDetailsExpandIcon = _ref.renderRowDetailsExpandIcon;
  if (renderRowDetailsExpandIcon) {
    return renderRowDetailsExpandIcon();
  }
  return ICON_EXPANDED;
};
var renderCollapsedIcon = function renderCollapsedIcon(_ref2) {
  var renderRowDetailsCollapsedIcon = _ref2.renderRowDetailsCollapsedIcon;
  if (renderRowDetailsCollapsedIcon) {
    return renderRowDetailsCollapsedIcon();
  }
  return ICON_COLLAPSED;
};
var rowDetailsRowIcons = function rowDetailsRowIcons(_ref3) {
  var isRowExpandable = _ref3.isRowExpandable,
    rowExpanded = _ref3.rowExpanded,
    toggleRowExpand = _ref3.toggleRowExpand,
    renderRowDetailsExpandIcon = _ref3.renderRowDetailsExpandIcon,
    renderRowDetailsCollapsedIcon = _ref3.renderRowDetailsCollapsedIcon;
  if (!isRowExpandable || !isRowExpandable()) {
    return;
  }
  var style = {
    cursor: 'pointer',
    position: 'relative',
    top: 1
  };
  return _react.default.cloneElement(rowExpanded ? renderExpandIcon({
    renderRowDetailsExpandIcon: renderRowDetailsExpandIcon
  }) : renderCollapsedIcon({
    renderRowDetailsCollapsedIcon: renderRowDetailsCollapsedIcon
  }), {
    style: style,
    key: 'toggle_icon',
    onClick: function onClick(event) {
      event.stopPropagation();
      toggleRowExpand();
    }
  });
};
var rowDetailsHeaderIcons = function rowDetailsHeaderIcons(_ref4) {
  var renderRowDetailsMoreIcon = _ref4.renderRowDetailsMoreIcon;
  if (renderRowDetailsMoreIcon) {
    return renderRowDetailsMoreIcon();
  }
  return ICON_MORE;
};
var _default = {
  id: _defaultRowExpandColumnId.id,
  rowExpandColumn: true,
  cellSelectable: false,
  headerAlign: 'center',
  textAlign: 'center',
  render: function render(_ref5) {
    var isRowExpandable = _ref5.isRowExpandable,
      rowExpanded = _ref5.rowExpanded,
      toggleRowExpand = _ref5.toggleRowExpand,
      renderRowDetailsExpandIcon = _ref5.renderRowDetailsExpandIcon,
      renderRowDetailsCollapsedIcon = _ref5.renderRowDetailsCollapsedIcon;
    return rowDetailsRowIcons({
      isRowExpandable: isRowExpandable,
      rowExpanded: rowExpanded,
      toggleRowExpand: toggleRowExpand,
      renderRowDetailsExpandIcon: renderRowDetailsExpandIcon,
      renderRowDetailsCollapsedIcon: renderRowDetailsCollapsedIcon
    });
  },
  header: function header(_ref6) {
    var renderRowDetailsMoreIcon = _ref6.renderRowDetailsMoreIcon;
    return rowDetailsHeaderIcons({
      renderRowDetailsMoreIcon: renderRowDetailsMoreIcon
    });
  },
  showInContextMenu: false,
  showColumnMenuSortOptions: false,
  showColumnMenuGroupOptions: false,
  showColumnMenuTool: false,
  sortable: false,
  editable: false,
  groupBy: false,
  defaultWidth: 50,
  minWidth: 40,
  isRowDetailsCell: true
};
exports.default = _default;